import { useLocation, useNavigate, useParams } from 'react-router';
import { useSearchParams } from 'react-router-dom';
import React from 'react';

export default function withRouter(Child) {
    return (props) => {
        const location = useLocation(),
            navigate = useNavigate(),
            params = useParams(),
            [searchParams] = useSearchParams();

        return <Child {...props} searchParams={searchParams} navigate={navigate} location={location} params={params} />;
    };
}
